module.exports = __webpack_public_path__ + "img/background-video-slider-kia.7fd7e29c.jpg";